<template>
    <v-dialog
        v-model="$store.state.posting.rdDialogTracking"
        width="1366px"
        style="background: #fff"
    >
        <v-toolbar color="primary" dense>
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text">Gps Tracking</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                dark
                icon
                left
                @click="$store.state.posting.rdDialogTracking = false"
                ><v-icon>mdi-close</v-icon></v-btn
            >
        </v-toolbar>
        <v-container fluid style="overflow: scroll; background: #fff">
            <div class="cActions">
                <div style="height: 120px">
                    <v-container fluid>
                        <div class="inl2">
                            <div class="linTab1 tbla">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Shift Date</th>
                                            <th>Shift Detail</th>
                                            <th>Driver</th>
                                            <th>Truck</th>
                                            <th>Yard</th>
                                            <th>Trailer</th>
                                            <th>Shift Start Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style="background-color:#fff">
                                                {{
                                                    comboDrivers.ShiftDate +
                                                        ' ' +
                                                        comboDrivers.Shift
                                                }}
                                            </td>
                                            <td style="background-color:#fff">
                                                {{
                                                    this.shiftDetails
                                                        .ShiftDetail
                                                }}
                                            </td>
                                            <td style="background-color:#fff">
                                                {{ this.shiftDetails.Driver }}
                                            </td>
                                            <td style="background-color:#fff">
                                                {{ this.shiftDetails.Truck }}
                                            </td>

                                            <td style="background-color:#fff">
                                                {{ this.shiftDetails.Yard }}
                                            </td>

                                            <td style="background-color:#fff">
                                                {{ this.shiftDetails.Trailer }}
                                            </td>
                                            <td style="background-color:#fff;">
                                                {{
                                                    shiftDetails.ShiftStartTime
                                                }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="linTab1 tbla">
                                <table>
                                    <tbody>
                                        <tr>
                                            <th>GPS Start Time</th>
                                            <th>GPS End Time</th>
                                        </tr>
                                        <tr>
                                            <td
                                                id="divs"
                                                style="background-color:#fff;border-bottom:1px solid #000;"
                                            >
                                                {{ shiftDetails.GPSShiftStart }}
                                            </td>
                                            <td
                                                id="divs"
                                                style="background-color:#fff;border-bottom:1px solid #000;"
                                            >
                                                {{ shiftDetails.GPSShiftEnd }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="inl3">
                            <div class="linCtm">
                                <v-textarea
                                    label="Comments"
                                    dense
                                    height="100"
                                    v-model="shiftDetails.GPSComments"
                                    outlined
                                    disabled
                                ></v-textarea>
                            </div>
                        </div>
                    </v-container>
                </div>
                <v-container grid-list-xs fluid>
                    <v-divider></v-divider>
                    <!--     ORDERS    -->
                    <div v-if="loadingOrders">
                        <v-progress-linear
                            :size="50"
                            color="primary"
                            indeterminate
                        ></v-progress-linear>
                    </div>
                    <div class="dspSum">
                        <div class="header">
                            <div class="sumTabs tbla">
                                <table>
                                    <thead>
                                        <th style="width: 8%">OrderID</th>
                                        <th style="width: 8%">Order Status</th>
                                        <th style="width: 2%">L1</th>
                                        <th style="width: 2%">L2</th>
                                        <th style="width: 15%">Terminal</th>
                                        <th style="width: 15%">Station</th>
                                        <th style="width: 8%">City</th>
                                        <th style="width: 10%">ETA</th>
                                        <th style="width: 10%">Run Out</th>
                                        <th style="width: 5%">Goal Post</th>
                                        <th style="width: 10%">Retain</th>
                                    </thead>
                                </table>
                            </div>
                            <div class="sumComt">
                                <table>
                                    <thead>
                                        <tr>
                                            <th></th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>

                        <div class="sumBody">
                            <div v-if="orders.length" style="height: 120px">
                                <div v-for="(order, i) in orders" :key="i">
                                    <div class="rowsCtm">
                                        <div class="tabs">
                                            <div class="lin2 linTab1 tbla">
                                                <table>
                                                    <tbody>
                                                        <tr class="tbFont">
                                                            <td
                                                                style="
                                                                    width: 8%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.OrderID
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                    width: 8%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.OrderStatus
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                    width: 2%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.LoadNum
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                    width: 2%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.LoadNumOrd
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                    width: 15%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.Terminal
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                    width: 15%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.Station
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                    width: 8%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.StationCity
                                                                }}
                                                            </td>

                                                            <td
                                                                style="
                                                                    width: 10%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.ETATime
                                                                }}
                                                            </td>

                                                            <td
                                                                style="
                                                                    width: 10%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.ROTime
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                    width: 5%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.GoalPost
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                    width: 10%;
                                                                    background: #01579b;
                                                                    color: #fff;
                                                                "
                                                            >
                                                                {{
                                                                    order.RTTime
                                                                }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="lin2 tbla">
                                                <div>
                                                    <table>
                                                        <thead class="tbFont">
                                                            <tr>
                                                                <th>
                                                                    Terminal
                                                                    Start
                                                                </th>
                                                                <th width="8%">
                                                                    Diff (hrs):
                                                                </th>
                                                                <th>
                                                                    Station
                                                                    Start
                                                                </th>
                                                                <th width="8%">
                                                                    Diff (hrs):
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody
                                                            style="
                                                                font-size: 10px;
                                                            "
                                                        >
                                                            <tr>
                                                                <td
                                                                    style="background-color:#fff"
                                                                >
                                                                    {{
                                                                        order.TStart
                                                                    }}
                                                                </td>
                                                                <td
                                                                    style="background-color:#fff"
                                                                >
                                                                    {{
                                                                        order.timeDiffT
                                                                    }}
                                                                </td>
                                                                <td
                                                                    style="background-color:#fff"
                                                                >
                                                                    {{
                                                                        order.StStart
                                                                    }}
                                                                </td>
                                                                <td
                                                                    style="background-color:#fff"
                                                                >
                                                                    {{
                                                                        order.timeDiffSt
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <thead class="tbFont">
                                                            <tr>
                                                                <th>
                                                                    Terminal End
                                                                </th>
                                                                <th
                                                                    width="8%"
                                                                ></th>
                                                                <th>
                                                                    Station End
                                                                </th>
                                                                <th width="8%">
                                                                    Open
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    style="background-color:#fff;border-bottom:1px solid #000;"
                                                                >
                                                                    {{
                                                                        order.TEnd
                                                                    }}
                                                                </td>
                                                                <td
                                                                    style="background-color:#fff;border-bottom:1px solid #000;"
                                                                ></td>
                                                                <td
                                                                    style="background-color:#fff;border-bottom:1px solid #000;"
                                                                >
                                                                    {{
                                                                        order.StEnd
                                                                    }}
                                                                </td>
                                                                <td
                                                                    style="background-color:#fff;border-bottom:1px solid #000;"
                                                                >
                                                                    <v-btn
                                                                        fab
                                                                        x-small
                                                                        icon
                                                                        color="primary"
                                                                        style="
                                                                            font-size: 10px;
                                                                            padding: 0px;
                                                                        "
                                                                        @click="
                                                                            openData(
                                                                                order
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            small
                                                                        >
                                                                            mdi-book-open</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="comt">
                                            <v-textarea
                                                label="Comments"
                                                v-model="order.GPSComments"
                                                outlined
                                                height="100px"
                                                disabled
                                            ></v-textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-container>
                <v-dialog
                    v-model="dialog"
                    width="500px"
                    class="dl"
                    transition="dialog-transition"
                >
                    <v-card>
                        <v-toolbar color="primary" dense>
                            <v-toolbar-title class="white--text"
                                >Amounts Modal</v-toolbar-title
                            >
                            <v-spacer></v-spacer>
                            <v-btn dark icon left @click="dialog = false"
                                ><v-icon>mdi-close</v-icon></v-btn
                            >
                        </v-toolbar>
                        <v-container grid-list-xs fluid>
                            <mdTracking v-if="dialog" :prm="data"></mdTracking>
                        </v-container>
                    </v-card>
                </v-dialog>
            </div>
        </v-container>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import mdTracking from './ReadModalTracking.vue';
import { mask } from 'vue-the-mask';
export default {
    name: 'Tracking',
    props: ['params'],
    components: {
        mdTracking
    },
    data: function() {
        return {
            indexShift: 0,
            indexDriver: 0,
            shiftDates: [],
            shiftDetailsDrivers: [],
            comboShiftDates: null,
            comboDrivers: null,
            shiftDetails: {},
            orders: [],
            data: [],
            dialog: false,
            saving: false,
            viewOrders: false,
            loadingOrders: false,
            productsOrder: [],
            headerProducts: [
                { text: 'Product', value: 'Product', width: '2' },
                { text: 'Ord QTY', value: 'Quantity', width: '2' },
                { text: 'Action', value: 'actions', width: '2' },
                { text: 'OrderID', value: 'OrderID', width: '2' }
            ],
            dateRules: [
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[11] + v[12]) <= 24 &&
                        parseInt(v[11] + v[12]) >= 0) ||
                    'Hour Incorrect',
                v =>
                    (parseInt(v[14] + v[15]) <= 59 &&
                        parseInt(v[14] + v[15]) >= 0) ||
                    'Minutes Incorrect'
            ]
        };
    },

    directives: {
        mask
    },

    mounted() {
        this.comboDrivers = this.params[0];
        this.showShiftDetails();
        console.log(this.params);
    },
    methods: {
        loadShiftDates: function() {
            this.$store.state.isLoading = true;
            axios
                .get('shift-header/dates')
                .then(response => {
                    this.shiftDates = response.data.data;
                    this.chargeShift();
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        openData: function(itm) {
            this.data = itm;
            this.dialog = true;
        },
        getShiftDetails: function() {
            this.$store.state.isLoading = true;
            axios
                .get('shift-detail/shift/' + this.parms[0].ShiftDetail)
                .then(response => {
                    console.log(response);
                    this.comboDrivers = null;
                    this.shiftDetails = {};
                    this.orders = {};
                    this.none();
                    this.viewOrders = false;
                    this.shiftDetailsDrivers = response.data;

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);

                    this.$store.state.isLoading = false;
                });
        },
        getOrdersByShiftDetail: function() {
            this.loadingOrders = true;
            this.$store.state.isLoading = true;
            axios
                .get('order/shift/' + this.shiftDetails.ShiftDetail)
                .then(response => {
                    this.loadingOrders = false;
                    var temp_orders = response.data;
                    console.log(temp_orders);

                    if (temp_orders) {
                        temp_orders.forEach((e, i) => {
                            temp_orders[i].timeDiffT = this.getTimeDiff(
                                temp_orders[i].TStart,
                                temp_orders[i].TEnd
                            );
                            temp_orders[i].timeDiffSt = this.getTimeDiff(
                                temp_orders[i].StStart,
                                temp_orders[i].StEnd
                            );
                            this.loadProductsOrder(temp_orders[i].OrderID);
                            console.log(this.productsOrder);
                            temp_orders[i].saving = false;
                        });
                    }

                    this.orders = temp_orders;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        showShiftDetails: function() {
            this.$store.state.isLoading = true;
            this.indexDriver = this.shiftDetailsDrivers.findIndex(elm => {
                return elm.ShiftDetail == this.comboDrivers.ShiftDetail;
            });
            console.log(this.indexDriver);
            this.$store.state.isLoading = true;
            var data = this.comboDrivers;
            this.shiftDetails = data;
            this.orders = {};
            this.none();
            this.viewOrders = false;
            this.getOrdersByShiftDetail();
            this.$store.state.isLoading = false;
            console.log(this.orders);
        },
        saveShiftDetails: function() {
            this.$store.state.isLoading = true;
            const delay = ms => new Promise(res => setTimeout(res, ms));
            let index = this.indexDriver;
            console.log('Hola' + this.indexDriver);
            this.saving = true;
            var params = {
                GPSShiftStart: this.getMsk('GPSShiftStart'),
                GPSShiftEnd: this.getMsk('GPSShiftEnd'),
                GPSComments: this.shiftDetails.GPSComments
            };
            console.log(params);
            axios
                .put('shift-detail/' + this.shiftDetails.ShiftDetail, params)
                // eslint-disable-next-line no-unused-vars
                .then(async response => {
                    this.shiftDetails.length = 0;
                    console.log(response.data);
                    this.saving = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Successfully updated.'
                    });
                    await this.getShiftDetails();
                    await delay(4000);
                    this.comboDrivers = this.shiftDetailsDrivers[index];
                    this.showShiftDetails();

                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.saving = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        },

        view: function() {
            this.viewOrders = !this.viewOrders;
            if (this.viewOrders) {
                this.all();
            } else {
                this.none();
            }
        },
        all: function() {
            this.panel = [...Array(this.orders.length).keys()].map((k, i) => i);
        },
        // Reset the panel
        none: function() {
            this.panel = [];
        },
        //format date yyyy-MM-ddThh:mm
        dateFormatDateTimeLocal: function(d) {
            if (d) {
                var date = moment(d);
                return date.format(moment.HTML5_FMT.DATETIME_LOCAL);
            }
        },
        //  format date YYYY-MM-DD HH:mm:ss
        dateFormatNormal: function(d) {
            if (d) {
                var date = moment(d);
                return date.format('YYYY-MM-DD HH:mm:ss');
            }
        },
        changeDateOrders: function(order, prop, value) {
            this.$store.state.isLoading = true;
            this.orders.forEach((e, i) => {
                if (e.OrderID == order.OrderID) {
                    this.orders[i][prop] = value;
                    this.orders[i].timeDiffT = this.getTimeDiff(
                        this.orders[i].TStart,
                        this.orders[i].TEnd
                    );
                    this.orders[i].timeDiffSt = this.getTimeDiff(
                        this.orders[i].StStart,
                        this.orders[i].StEnd
                    );
                }
            });
            this.$store.state.isLoading = false;
        },
        loadProductsOrder: function(orderID) {
            this.productsOrder.length = 0;
            axios
                .get('order-detail/order/' + orderID)
                .then(response => {
                    this.productsOrder.push(response.data.data);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getTimeDiff: function(start_date, end_date) {
            var duration;
            var hours;

            if (start_date !== undefined && end_date !== undefined) {
                var start = moment(start_date);
                var end = moment(end_date);
                duration = moment.duration(end.diff(start));
                hours = duration.asHours().toFixed(2);
            } else {
                hours = 'N/A';
            }

            return hours;
        },

        getMsk: function(id) {
            return document.getElementById(id).value;
        },
        callAsync: async function(x) {
            await this.getShiftDetails();

            this.comboDrivers = this.shiftDetailsDrivers[x];
            this.showShiftDetails();
        }
    }
};
</script>

<style>
* {
    padding: 0px;
    margin: 0px;
}
.contain {
    padding: 10px;
}
#combox .v-list-item__title {
    font-size: 10px !important;
}
.lin1 {
    display: inline-block;
    width: 49%;
    margin-left: 1%;
}
.linTab1 {
    width: 100%;
}
.tbla table {
    float: left;
    margin-top: 2px;
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}
.tbla th {
    text-align: center;
    padding: 2px;
    font-size: 10px;
    background: #adbbcc;
    border-bottom: 1px solid #dddddd;
    color: #000;
}
.tbla td {
    border: 1px solid #fff;
    background: #ddd;
    text-align: center;
    padding: 0.5px;
    font-size: 12px;
}
.lin2 {
    margin-left: 4px;
    width: 100%;
}
.inl1 {
    float: left;
    display: inline-block;
    width: 20%;
}
.inl2 {
    float: left;
    display: inline-block;
    width: 64%;
    margin-left: 1%;
}
.inl3 {
    display: inline-block;
    float: right;
    width: 34%;
    margin-left: 1%;
}
.cardM {
    padding: 0px;
    margin: 0px;
}
.v-list-item__content {
    font-size: 16px;
}
.cActions {
    min-height: 600px;
}
.linCtm {
    width: 100%;
    display: inline-block;
}
.linCtmB {
    width: 10%;
    display: inline-block;
}
.dspSum {
}
.sumTabs {
    width: 70%;
    display: inline-block;
}
.sumComt {
    width: 29%;
    margin-left: 1%;
    display: inline-block;
}
.comt {
    width: 29%;
    margin-left: 1%;
    display: inline-block;
    float: right;
}
.tabs {
    width: 70%;
    display: inline-block;
    float: left;
}
.rowsCtm {
    width: 100%;
    float: left;
}

.tbFont {
    font-size: 8px;
}
.tbFont td {
    background: #fff;
}
#divs .v-text-field__details {
    display: none;
}
.sumBody {
    background: #fff;
}
</style>
